import { useField } from 'formik';
import { Grid, Theme } from '@mui/material';
import { MuiColorInput } from 'mui-color-input';
import React from 'react';
import Typography from '@mui/material/Typography';
import { StyledErrorMessage } from '../StyledErrorMessage';

export const FormFieldColorPicker = ({
  label,
  fieldName,
  disabled,
  tooltip,
}: {
  label?: string;
  fieldName: string;
  disabled: boolean;
  tooltip: string;
}) => {
  const [field, _, helpers] = useField(fieldName);

  const handleChange = (newValue: string) => {
    void helpers.setValue(newValue);
  };

  return (
    <Grid container alignItems="center" gap={1}>
      {label && (
        <Typography>
          <label htmlFor={fieldName}>{label}</label>
        </Typography>
      )}

      <MuiColorInput
        disabled={disabled}
        {...field}
        value={field.value || ''}
        onChange={handleChange}
        format="hex"
        isAlphaHidden
        inputProps={{ dir: 'ltr' }}
        sx={{
          maxWidth: 160,
          '& .MuiInputBase-input': { fontVariantNumeric: 'tabular-nums' },
          '& .MuiColorInput-Button': {
            width: 44,
            height: 44,
            borderRadius: '6px',
            boxShadow: (theme: Theme) => `inset 0 0 0 1px ${theme.palette.divider}`,
          },
        }}
      />
      <Typography fontSize="14px" color="text.secondary" sx={{ flexBasis: '100%' }}>
        {tooltip}
      </Typography>
      <StyledErrorMessage name={fieldName} />
    </Grid>
  );
};
